import F from "../../../../_virtual/isNil.js";
import { isValidElement as B } from "react";
import K from "../../../../_virtual/isFunction.js";
import { getPercentValue as A } from "./DataUtils.js";
import { parseScale as V, checkDomainOfScale as k, getTicksOfScale as q } from "./ChartUtils.js";
function h(t) {
  "@babel/helpers - typeof";
  return h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, h(t);
}
function M(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function y(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? M(Object(r), !0).forEach(function(n) {
      j(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : M(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function j(t, e, r) {
  return e = H(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function H(t) {
  var e = L(t, "string");
  return h(e) == "symbol" ? e : e + "";
}
function L(t, e) {
  if (h(t) != "object" || !t) return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e);
    if (h(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function U(t, e) {
  return G(t) || z(t, e) || $(t, e) || W();
}
function W() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $(t, e) {
  if (t) {
    if (typeof t == "string") return P(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set") return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return P(t, e);
  }
}
function P(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function z(t, e) {
  var r = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r != null) {
    var n, i, o, a, l = [], s = !0, f = !1;
    try {
      if (o = (r = r.call(t)).next, e !== 0) for (; !(s = (n = o.call(r)).done) && (l.push(n.value), l.length !== e); s = !0) ;
    } catch (b) {
      f = !0, i = b;
    } finally {
      try {
        if (!s && r.return != null && (a = r.return(), Object(a) !== a)) return;
      } finally {
        if (f) throw i;
      }
    }
    return l;
  }
}
function G(t) {
  if (Array.isArray(t)) return t;
}
var R = Math.PI / 180, J = function(e) {
  return e * 180 / Math.PI;
}, oe = function(e, r, n, i) {
  return {
    x: e + Math.cos(-R * i) * n,
    y: r + Math.sin(-R * i) * n
  };
}, Q = function(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(e - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, le = function(e, r, n, i, o) {
  var a = e.width, l = e.height, s = e.startAngle, f = e.endAngle, b = A(e.cx, a, a / 2), v = A(e.cy, l, l / 2), c = Q(a, l, n), u = A(e.innerRadius, c, 0), m = A(e.outerRadius, c, c * 0.8), T = Object.keys(r);
  return T.reduce(function(I, O) {
    var d = r[O], C = d.domain, D = d.reversed, g;
    if (F(d.range))
      i === "angleAxis" ? g = [s, f] : i === "radiusAxis" && (g = [u, m]), D && (g = [g[1], g[0]]);
    else {
      g = d.range;
      var _ = g, S = U(_, 2);
      s = S[0], f = S[1];
    }
    var x = V(d, o), w = x.realScaleType, p = x.scale;
    p.domain(C).range(g), k(p);
    var N = q(p, y(y({}, d), {}, {
      realScaleType: w
    })), E = y(y(y({}, d), N), {}, {
      range: g,
      radius: m,
      realScaleType: w,
      scale: p,
      cx: b,
      cy: v,
      innerRadius: u,
      outerRadius: m,
      startAngle: s,
      endAngle: f
    });
    return y(y({}, I), {}, j({}, O, E));
  }, {});
}, X = function(e, r) {
  var n = e.x, i = e.y, o = r.x, a = r.y;
  return Math.sqrt(Math.pow(n - o, 2) + Math.pow(i - a, 2));
}, Y = function(e, r) {
  var n = e.x, i = e.y, o = r.cx, a = r.cy, l = X({
    x: n,
    y: i
  }, {
    x: o,
    y: a
  });
  if (l <= 0)
    return {
      radius: l
    };
  var s = (n - o) / l, f = Math.acos(s);
  return i > a && (f = 2 * Math.PI - f), {
    radius: l,
    angle: J(f),
    angleInRadian: f
  };
}, Z = function(e) {
  var r = e.startAngle, n = e.endAngle, i = Math.floor(r / 360), o = Math.floor(n / 360), a = Math.min(i, o);
  return {
    startAngle: r - a * 360,
    endAngle: n - a * 360
  };
}, ee = function(e, r) {
  var n = r.startAngle, i = r.endAngle, o = Math.floor(n / 360), a = Math.floor(i / 360), l = Math.min(o, a);
  return e + l * 360;
}, ue = function(e, r) {
  var n = e.x, i = e.y, o = Y({
    x: n,
    y: i
  }, r), a = o.radius, l = o.angle, s = r.innerRadius, f = r.outerRadius;
  if (a < s || a > f)
    return !1;
  if (a === 0)
    return !0;
  var b = Z(r), v = b.startAngle, c = b.endAngle, u = l, m;
  if (v <= c) {
    for (; u > c; )
      u -= 360;
    for (; u < v; )
      u += 360;
    m = u >= v && u <= c;
  } else {
    for (; u > v; )
      u -= 360;
    for (; u < c; )
      u += 360;
    m = u >= c && u <= v;
  }
  return m ? y(y({}, r), {}, {
    radius: a,
    angle: ee(u, r)
  }) : null;
}, fe = function(e) {
  return !/* @__PURE__ */ B(e) && !K(e) && typeof e != "boolean" ? e.className : "";
};
export {
  R as RADIAN,
  X as distanceBetweenPoints,
  Z as formatAngleOfSector,
  le as formatAxisMap,
  Y as getAngleOfPoint,
  Q as getMaxRadius,
  fe as getTickClassName,
  ue as inRangeOfSector,
  oe as polarToCartesian,
  J as radianToDegree
};
